export class ApplicationRoutes {
	static readonly LANDING_PAGE = "/";
	static readonly RECOMMENDATION = "/recommendation";
	static readonly RECOMMENDATION_FINALIZATION = "/recommendation/finalize";
	static readonly RECOMMENDATION_OVERVIEW = "/recommendation/overview";
	static readonly RECOMMENDATION_PRODUCTS = "/recommendation/products";
	static readonly RECOMMENDATION_PRODUCT_DETAILS = "/recommendation/products/:id";
	static readonly RECOMMENDATION_PRODUCT_CONFIRMATION = "/recommendation/products/:id/confirmation";
	static readonly LOGIN = "/login";
	static readonly FORGOT_PASSWORD = "/forgot-password/:token";

	static readonly TERMS = "/terms";
	static readonly PRIVACY_POLICY = "/privacy-policy";
	static readonly DELETE_INSTRUCTION = "/delete-account-instruction";
	static readonly COMING_SOON = "/coming-soon"
	static readonly FAQ = "/#got-questions-section";
	static readonly BENEFITS = "/#benefits";

	static readonly PRODUCTS = "products";

	static readonly PROVIDER_BASE = "/provider";
	static readonly PROVIDER_SIGNUP = "/provider/signup";
	static readonly PROVIDER_SIGNUP_CONFIRMATION = "/provider/signup/confirmation/:code";
	static readonly PROVIDER_TEAM_MEMBER_CONFIRMATION = "/provider/team-members/confirmation/:code";
	static readonly CUSTOMER_CONFIRMATION = "/customer/signup/confirmation/:registrationId";
	static readonly PROVIDER_CUSTOMERS = "customers";

	static readonly ADMIN_BASE = "/admin";
	static readonly PRODUCTS_CATEGORY = "products-category";
	static readonly ADVERT_BANNER = "store-banner";

	static readonly DASHBOARD = "dashboard";
	static readonly SOLAR_PROVIDER = "solar-provider";
	static readonly PROVIDER_COMPANY_FIRST_LOGIN = "first-login/";
	static readonly APPLIANCE_CATEGORIES = "appliance-categories";
	static readonly SEARCH_PARAMETER = "search-parameter";
	static readonly PROVIDER_TEAM_MEMBERS = "team-members";
	static readonly CREATE_PRODUCT = "products/create";
	static readonly EDIT_PRODUCT = "products/edit/";
	static readonly PROVIDER_ADD_TEAM_MEMBER = "team-members/add";
	static readonly LOAN_PRODUCTS = "loan-products";
	static readonly LOAN_REQUEST = "loan-request";
	static readonly LOAN_SUMMARY = "loan-summary";
	static readonly PAYMENTS = "payments";
	static readonly ROOF_TYPE = "roof-type";

	static readonly CUSTOMER_SIGNUP = "/customer/signup";
	static readonly CUSTOMER_BASE = "customer";
	static readonly CUSTOMER_DASHBOARD = "dashboard";
	static readonly CUSTOMER_ORDERS = "orders";

	static readonly NEW_CUSTOMER_SIGNUP_USER_INFORMATION = "/customer/signup/user-information";
	static readonly NEW_CUSTOMER_SIGNUP_OTP = "/customer/signup/otp";
	static readonly NEW_CUSTOMER_SIGNUP_NEXT_STEP = "/customer/signup/next-step";
	
	static readonly CUSTOMER_NEXT_STEP = "/customer/next-step";

	static readonly STORE_FRONT = "/store";
	static readonly STORE_FRONT_CATEGORY = "/store/category/:category";
	static readonly STORE_FRONT_ITEM = "/store/item";
	static readonly CONFIRM_ORDER = "/confirm-order";
	static readonly CHECKOUT = "/checkout"
	static readonly WISHLIST = "/store/wishlist"
	static readonly BILLING_INFO = "/store/billing-info" 
	static readonly CONFIRM_PAYMENT = "/confirm-payment";
}
